<template>
  <button type="button" class="btn btn-default" style="margin-right: 5px;" @click="debouncedBackToWork">{{ $t( 'toolbar.back_to_work') }} {{ name }}</button>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { debounce } from 'lodash';

export default {
  name: 'BackToWorkButton',
  methods: mapActions([
    'backToWork'
  ]),
  computed: {
    ...mapState({
      templateName: state => state.templateName
    }),
    name: function () {
      if (this.templateName === undefined || this.templateName === '') {
        return '--';
      }
      return this.templateName;
    }
  },
  created: function() {
    const that = this;
    this.debouncedBackToWork = debounce(function() {
      that.backToWork();
    }, 500);
  }
};
</script>

<style scoped>
</style>
